import React from 'react';
import { ChatMessage as ChatMessageType } from '../types/chat.types';
import '../styles/ChatMessage.css';

interface ChatMessageProps {
  message: ChatMessageType;
  onFeedback?: (messageId: string, feedback: 'positive' | 'negative') => void;
}

export const ChatMessage: React.FC<ChatMessageProps> = ({ message, onFeedback }) => {
  const isUser = message.role === 'user';

  const handleFeedback = (feedback: 'positive' | 'negative') => {
    if (onFeedback) {
      onFeedback(message.id, feedback);
    }
  };

  return (
    <div className={`chat-message ${isUser ? 'chat-message-user' : 'chat-message-assistant'}`}>
      <div className="chat-message-content">
        <div className="chat-message-text">{message.message}</div>
        {message.timestamp && (
          <div className="chat-message-timestamp">
            {new Date(message.timestamp).toLocaleTimeString([], {
              hour: '2-digit',
              minute: '2-digit'
            })}
          </div>
        )}
      </div>

      {!isUser && message.sources && message.sources.length > 0 && (
        <div className="chat-message-sources">
          <div className="chat-message-sources-title">Sources:</div>
          {message.sources.map((source, index) => (
            <div key={index} className="chat-message-source">
              {source.url ? (
                <a href={source.url} target="_blank" rel="noopener noreferrer">
                  {source.title}
                </a>
              ) : (
                <span>{source.title}</span>
              )}
            </div>
          ))}
        </div>
      )}

      {!isUser && onFeedback && (
        <div className="chat-message-feedback">
          <button
            className="chat-message-feedback-btn"
            onClick={() => handleFeedback('positive')}
            title="Helpful"
          >
            👍
          </button>
          <button
            className="chat-message-feedback-btn"
            onClick={() => handleFeedback('negative')}
            title="Not helpful"
          >
            👎
          </button>
        </div>
      )}
    </div>
  );
};
